import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
  _AbcCheckBoxComponent,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { ValuesEditorComponent } from './values-editor.component';
import { AbcIconComponent } from '@barthauer/abc/ui-components';

@NgModule({
  declarations: [ValuesEditorComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    AbcTextBoxComponent,
    _AbcCheckBoxComponent,
    AbcDateBoxComponent,
    AbcNumberBoxComponent,
    _AbcTextAreaComponent,
    AbcDropDownBoxComponent,
    _AbcSelectBoxComponent,
    _AbcGridComponent,
    AbcIconComponent,
  ],
  exports: [ValuesEditorComponent],
})
export class ParamValuesEditorModule {}
